import { language as lan_paymentComplete } from "./payment-complete";
import { language as lan_paymentCancel } from "./payment-cancel";
import { language as lan_standardComplete } from "./standard-complete";
import { language as lan_standardCancel } from "./standard-cancel";
import { language as lan_bankTransferIntro } from "./bank-transfer-intro/index";

let language = {
    ...lan_paymentComplete,
    ...lan_paymentCancel,
    ...lan_standardComplete,
    ...lan_standardCancel,
    ...lan_bankTransferIntro
};

export { language }